export class employmentTypeUpdateRequest {
  empTypeId?:number;
  employmentType:string;
  createdUser:number | null;
  updatedUser: number | null;
  versionFlag: number;
}
export class employmentTypeIdRequest {
  employmentTypeId:string;
  updatedUser: number | null;
  versionFlag: number;
}